'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getScrollAncestor = exports.canScroll = undefined;

var _featureDetection = require('../feature-detection');

var isScrollStyleValue = function isScrollStyleValue(value) {
    return value === 'auto' || value === 'scroll';
};

/**
 * Determines whether a given dom element is scrollable
 * @param {Element} element - DOM element to inspect
 * @returns {boolean}
 */
var canScroll = exports.canScroll = function canScroll(element) {
    // window is necessary to use getComputedStyle
    if (!_featureDetection.HAS_WINDOW) {
        return null;
    }

    var styles = getComputedStyle(element);

    return isScrollStyleValue(styles.overflow) || isScrollStyleValue(styles.overflowX) || isScrollStyleValue(styles.overflowY);
};

/**
 * Returns the first scrollable ancestor that is scrollable.
 * @param {Element} element - DOM element on which to find scroll ancestor
 * @returns {Element}
 */
var getScrollAncestor = exports.getScrollAncestor = function getScrollAncestor(element) {
    if (!element || !element.parentElement) {
        return null;
    }

    var currentElement = element.parentElement;

    while (currentElement) {
        if (canScroll(currentElement)) {
            return currentElement;
        }
        currentElement = currentElement.parentElement;
    }

    return null;
};